import { JSONSchemaType } from 'ajv';

import { t } from '../../config/translations';
import { OrderLine } from '../types';

export const orderLineSchema: JSONSchemaType<OrderLine> = {
  title: 'Order line',
  type: 'object',
  properties: {
    desi: {
      type: 'string',
      get title() {
        return t('schema.designation');
      },
      decorators: { search: true, copy: true },
    },
    nart: {
      type: 'string',
      get title() {
        return t('schema.articleRef');
      },
      decorators: { search: true, copy: true },
    },
    qcde: {
      type: 'string',
      get title() {
        return t('schema.qtyOrdered');
      },
      decorators: { search: true },
    },
    uncd: {
      type: 'string',
      get title() {
        return t('schema.unit');
      },
      decorators: { search: true },
    },
    punt: {
      type: 'string',
      get title() {
        return t('schema.price');
      },
      decorators: {
        search: true,
        numeral: { currencySymbol: '€' },
      },
    },
    mnld: {
      type: 'string',
      get title() {
        return t('schema.total');
      },
      decorators: {
        search: true,
        numeral: { currencySymbol: '€' },
      },
    },
    ndoc: {
      type: 'integer',
      get title() {
        return t('schema.orderRef');
      },
    },
    non_valide: {
      type: 'integer',
      get title() {
        return t('schema.isReturnable');
      },
    },
    student: {
      type: 'boolean',
      get title() {
        return t('schema.schoolClient');
      },
      decorators: { hide: ['details'] },
      nullable: true,
    },
  },
  required: [],
};
